import { EventBus, EVENT_BUS } from './eventBus';

export const ResizerModule = (function () {
  const MIN_WIDTH = 250;
  const MAX_WIDTH = 600;

  const setElementWidth = (element, width) => {
    element.style.width = `${width}px`;
    element.style.flexBasis = `${width}px`;
  };

  const initResizer = (element, storageKey, side = 'right') => {
    if (!element) return;

    const resizer = document.createElement('div');
    resizer.className = `resizer resizer-${side}`;
    element.appendChild(resizer);

    const savedWidth = localStorage.getItem(storageKey);
    if (savedWidth && !element.classList.contains('closed')) {
      setElementWidth(element, savedWidth, storageKey);
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          const isClosed = element.classList.contains('closed');
          if (isClosed) {
            element.style.flexBasis = '';
            element.style.width = '';
          } else {
            const savedWidth = localStorage.getItem(storageKey);
            if (savedWidth) {
              setElementWidth(element, savedWidth, storageKey);
            }
          }
        }
      });
    });

    observer.observe(element, { attributes: true });

    let isResizing = false;
    let startX;
    let startWidth;

    const startResize = (e) => {
      isResizing = true;
      startX = e.pageX || e.touches[0].pageX;
      startWidth = element.offsetWidth;

      document.body.classList.add('resizing');
      EventBus.emit(EVENT_BUS.EVENTS.RESIZER.START);

      e.preventDefault();
    };

    const moveResize = (e) => {
      if (!isResizing) return;

      const currentX = e.pageX || e.touches[0].pageX;
      const diff = side === 'right' ? currentX - startX : startX - currentX;

      let newWidth = startWidth + diff;
      newWidth = Math.max(MIN_WIDTH, Math.min(newWidth, MAX_WIDTH));

      if (!element.classList.contains('closed')) {
        setElementWidth(element, newWidth, storageKey);
      }
    };

    const endResize = () => {
      if (!isResizing) return;

      isResizing = false;
      document.body.classList.remove('resizing');
      EventBus.emit(EVENT_BUS.EVENTS.RESIZER.END);

      if (!element.classList.contains('closed')) {
        localStorage.setItem(storageKey, element.offsetWidth);
      }
    };

    resizer.addEventListener('mousedown', startResize);
    document.addEventListener('mousemove', moveResize);
    document.addEventListener('mouseup', endResize);

    resizer.addEventListener('touchstart', startResize, { passive: false });
    document.addEventListener('touchmove', moveResize, { passive: false });
    document.addEventListener('touchend', endResize);

    window.addEventListener('resize', () => {
      if (!element.classList.contains('closed')) {
        const savedWidth = localStorage.getItem(storageKey);
        if (savedWidth) {
          setElementWidth(element, savedWidth, storageKey);
        }
      }
    });
  };

  const init = () => {
    const leftMenu = document.querySelector('.content.toggleable-content');
    initResizer(leftMenu, 'leftMenuWidth', 'right');

    const rightMenu = document.querySelector('.anchors');
    initResizer(rightMenu, 'anchorsWidth', 'left');
  };

  return {
    init,
  };
})();
